<!--学校统计看板  -->
<template>
    <div class="stat-container">
        <!--左栏-->
        <div class="l-stat-container">
            <div class="org-container">
                <div class="org-logo-container">
                    <img class="org-logo" alt="" :src="userInfo.avatar + '?_=' + Date.now()" >
                </div>
                <div class="school-name-container">{{schoolInfo.orgName}}</div>
                <div class="org-name-container">{{schoolInfo.parentOrgName}}</div>
            </div>
            <div class="menu-container">
                <div @click="changeItem('1')" :class="activeItem==='1'?'menu-item menu-active':'menu-item'">教师发展</div>
                <div @click="changeItem('2')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">协同备课</div>
                <div @click="changeItem('3')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">听评课</div>
            </div>
        </div>
        <!--右栏-->
        <div class="r-stat-container">
            <div class="school-info-container">
                <div class="l-school-info-container"></div>
                <div class="r-school-info-container">
                    <div class="r-school-info-container-child1">{{schoolInfo.orgName}}</div>
                    <div class="r-school-info-container-child2">校区综合数据看板</div>
                </div>
                <div class="l-school-info-container">
                    <el-select @change="schoolChange" v-if="schoolList&&schoolList.length>1"
                               v-model="schoolId"
                               filterable
                               style="width: 140px;margin-top: 20px"
                               placeholder="请选择学校">
                        <el-option v-for="item in schoolList" :key="item.orgId" :label="item.orgName"
                                   :value="item.orgId" />
                    </el-select>
                </div>
            </div>
            <!-- 数据看板-教师发展 -->
            <div class="dashboard-container" v-if="activeItem==='1'">
                <div class="data-info-container">
                    <div class="data-container-child1">
                        <div class="data-title-1">{{teaData.teacherCount}}</div>
                        <div class="data-title-2">教师数量</div>
                    </div>
                    <div class="data-container-child1">
                        <div class="data-title-1">{{teaData.rankTeacherCount}}</div>
                        <div class="data-title-2">高职称教师数量</div>
                    </div>
                    <div class="data-container-child1">
                        <div class="data-title-1">{{teaData.backboneTeacherCount}}</div>
                        <div class="data-title-2">骨干教师数量</div>
                    </div>
                    <div class="data-container-child12">
                        <div class="data-title-1">{{teaData.eduTeacherCount}}</div>
                        <div class="data-title-2">高学历教师数量</div>
                    </div>
                </div>
                <div class="data-dashboard-top">
                    <div class="data-dashboard1" v-loading="loading1">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">教师概况</div>
                                <div :class="period1==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period1==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period1==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'3')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper"></div>
                        </div>
                        <div class="data-echarts-container">
                            <div class="data-echarts-item">
                                <tea-xb-echart :man-count="teaOverview.manTeacherCount" :woman-count="teaOverview.womanTeacherCount" />
                                <div class="item_container">
                                    <div class="item_01">
                                        <div class="item_color1"></div>
                                        <div class="item_info">
                                            <div class="item_info_c1">男教师</div>
                                            <div class="item_info_c2">{{teaOverview.manTeacherRate}}%</div>
                                        </div>
                                    </div>
                                    <div class="item_01">
                                        <div class="item_color2"></div>
                                        <div class="item_info">
                                            <div class="item_info_c1">女教师</div>
                                            <div class="item_info_c2">{{100-teaOverview.manTeacherRate}}%</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="data-echarts-item">
                                <tea-xl-echart :tea-count1="teaOverview.ssTeacherCount"
                                               :tea-count2="teaOverview.bkTeacherCount"
                                               :tea-count3="teaOverview.zkTeacherCount" />
                                <div class="item_container">
                                    <div class="item_01">
                                        <div class="item_color1"></div>
                                        <div class="item_info">
                                            <div class="item_info_c1">硕士及以上</div>
                                            <div class="item_info_c2">{{teaOverview.ssTeacherRate}}%</div>
                                        </div>
                                    </div>
                                    <div class="item_01">
                                        <div class="item_color2"></div>
                                        <div class="item_info">
                                            <div class="item_info_c1">大学本科</div>
                                            <div class="item_info_c2">{{teaOverview.bkTeacherRate}}%</div>
                                        </div>
                                    </div>
                                    <div class="item_01">
                                        <div class="item_color3"></div>
                                        <div class="item_info">
                                            <div class="item_info_c1">专科及以下</div>
                                            <div class="item_info_c2">{{teaOverview.zkTeacherRate}}%</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="data-echarts-item">
                                <tea-zc-echart :tea-zc-count1="teaOverview.gjRankTeacherCount"
                                               :tea-zc-count2="teaOverview.yjRankTeacherCount"
                                               :tea-zc-count3="teaOverview.ejRankTeacherCount" />
                                <div class="item_container">
                                    <div class="item_01">
                                        <div class="item_color1"></div>
                                        <div class="item_info">
                                            <div class="item_info_c1">高级及以上</div>
                                            <div class="item_info_c2">{{teaOverview.gjRankTeacherRate}}%</div>
                                        </div>
                                    </div>
                                    <div class="item_01">
                                        <div class="item_color2"></div>
                                        <div class="item_info">
                                            <div class="item_info_c1">一级教师</div>
                                            <div class="item_info_c2">{{teaOverview.yjRankTeacherRate}}%</div>
                                        </div>
                                    </div>
                                    <div class="item_01">
                                        <div class="item_color4"></div>
                                        <div class="item_info">
                                            <div class="item_info_c1">二级及其他</div>
                                            <div class="item_info_c2">{{teaOverview.ejRankTeacherRate}}%</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="data-dashboard1" v-loading="loading2">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">教师年龄分布</div>
                                <div :class="period2==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period2==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period2==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'3')"  v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper"></div>
                        </div>
                        <div class="data-echarts-container">
                            <tea-age-echart  :age1-count="teaAge.age1Count"
                                             :age2-count="teaAge.age2Count"
                                             :age3-count="teaAge.age3Count"
                                             :age4-count="teaAge.age4Count"
                                             :age5-count="teaAge.age5Count"
                                             :age6-count="teaAge.age6Count"/>
                        </div>
                    </div>
                    <div class="data-dashboard2" v-loading="loading3">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">教师教龄分布</div>
                                <div :class="period3==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period3==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period3==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'3')"  v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper"></div>
                        </div>
                        <div class="data-echarts-container">
                            <tea-work-age-echart :count-list="teaWorkAge.countList" :item-list="teaWorkAge.itemList"/>
                        </div>
                    </div>
                </div>
                <div class="data-dashboard-bottom">
                    <div class="data-dashboard1" v-loading="loading4">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">教师学科分布</div>
                                <div :class="period4==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period4==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period4==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'3')"  v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper"></div>
                        </div>
                        <div class="data-echarts-container">
                            <tea-subject-echart :count-list="teaSubject.countList" :item-list="teaSubject.itemList"/>
                        </div>
                    </div>
                    <div class="data-dashboard1" v-loading="loading5">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">学科新老教师分布</div>
                                <div :class="period5==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(5,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period5==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(5,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period5==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(5,'3')"  v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper"></div>
                        </div>
                        <div class="data-echarts-container01">
                            <tea-work-age-subject-echart :one-count-list="teaTeachAgeSubject.oneCountList"
                                                         :two-count-list="teaTeachAgeSubject.twoCountList"
                                                         :three-count-list="teaTeachAgeSubject.threeCountList"
                                                         :four-count-list="teaTeachAgeSubject.fourCountList"
                                                         :item-list="teaTeachAgeSubject.itemList" />
                        </div>
                        <div class="echarts-color-item-container">
                            <div class="echarts-color1"></div>
                            <div class="echarts-color-title">教龄1-5年</div>
                            <div class="echarts-color2"></div>
                            <div class="echarts-color-title">教龄5-10年</div>
                            <div class="echarts-color3"></div>
                            <div class="echarts-color-title">教龄10年以上</div>
                            <div class="echarts-color4"></div>
                            <div class="echarts-color-title">其他</div>
                        </div>
                    </div>
                    <div class="data-dashboard2" v-loading="loading6">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">教师岗位分布</div>
                            </div>
                            <div class="data-dashboard-oper" @click="createPostInfo" v-if="role === '1'">
                                <svg t="1758877934180" style="margin-top: 5px;margin-left: 50px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5665" width="18" height="18"><path d="M999.397669 686.08a88.259048 88.259048 0 0 0-5.071239-23.210667l-0.243809-0.536381a104.20419 104.20419 0 0 0-19.163429-29.549714 90.794667 90.794667 0 0 0-24.624762-19.748571 69.729524 69.729524 0 0 0-27.209142-7.996953c-1.316571-0.146286-2.730667-0.146286-4.047238-0.146285a42.715429 42.715429 0 0 0-29.93981 12.385523c-4.583619 3.510857-34.133333 29.842286-34.133333 29.842286l101.180952 100.108191 6.534095-4.486096c2.974476-2.096762 5.705143-4.534857 8.289524-7.119238 2.925714-2.730667 22.918095-26.965333 22.918095-26.965333A40.96 40.96 0 0 0 999.44643 686.08z m-163.05981-19.163429c-33.255619 32.621714-67.145143 66.072381-100.742095 99.57181-12.580571 12.53181-25.014857 25.209905-37.449143 37.888-11.117714 11.361524-22.528 22.966857-34.03581 34.474667l-25.795047 25.843809-13.458286 13.409524c-8.094476 7.801905-14.774857 17.066667-19.651048 27.355429-2.340571 5.36381-4.388571 10.873905-5.997714 16.237714l-8.143238 24.185905c-2.876952 8.777143-5.36381 17.554286-7.558095 25.941333a294.326857 294.326857 0 0 0-4.33981 18.675809 32.280381 32.280381 0 0 0 3.169524 24.527239l0.877714 1.56038 1.316572 1.170286a27.843048 27.843048 0 0 0 25.014857 5.217524 265.752381 265.752381 0 0 0 18.822095-4.388571 649.264762 649.264762 0 0 0 52.857905-16.384c6.972952-2.243048 13.897143-5.071238 20.821333-8.289524 4.973714-2.389333 9.752381-5.36381 14.140953-8.630857l11.897904-9.264762 11.702858-11.849143a624.152381 624.152381 0 0 1 24.039619-24.576l71.728762-71.338667 107.715047-107.617524-100.10819-100.352-6.826667 6.631619zM281.08605 173.933714a48.420571 48.420571 0 0 0 48.128-48.469333V48.469333A48.420571 48.420571 0 0 0 281.08605 0a48.420571 48.420571 0 0 0-48.176762 48.469333v77.04381c0 26.819048 21.601524 48.469333 48.176762 48.469333z m106.788571-43.446857h135.558095c21.211429 0 38.521905-17.749333 38.521905-39.545905a39.15581 39.15581 0 0 0-38.521905-39.497142h-135.558095a39.107048 39.107048 0 0 0-38.570667 39.497142 39.009524 39.009524 0 0 0 38.521905 39.497143z m254.390857 43.495619a48.420571 48.420571 0 0 0 48.176762-48.518095V48.469333A48.420571 48.420571 0 0 0 642.265478 0a48.420571 48.420571 0 0 0-48.176762 48.469333v77.04381c0.146286 26.819048 21.601524 48.469333 48.176762 48.469333zM229.495954 391.41181h460.312381c22.430476 0 40.764952-18.578286 40.764953-41.496381a41.155048 41.155048 0 0 0-40.764953-41.545143H229.495954a41.155048 41.155048 0 0 0-40.764952 41.545143c0 22.918095 18.285714 41.496381 40.764952 41.496381z m460.312381 67.193904H229.495954a41.155048 41.155048 0 0 0-40.764952 41.545143c0 22.918095 18.285714 41.496381 40.764952 41.496381h460.312381c22.430476 0 40.764952-18.578286 40.764953-41.496381a41.155048 41.155048 0 0 0-40.764953-41.545143z m62.902857-330.849524h42.910477c10.532571 0 19.163429 8.582095 19.163428 19.065905v493.665524l76.312381-70.607238V146.968381a95.573333 95.573333 0 0 0-95.475809-95.573333h-42.910477a38.278095 38.278095 0 0 0-38.229333 38.229333c0 20.967619 17.16419 38.13181 38.229333 38.131809zM119.781669 919.649524a19.163429 19.163429 0 0 1-19.163429-19.114667V147.163429c0-10.48381 8.630857-19.065905 19.163429-19.065905h31.890285a38.326857 38.326857 0 0 0 0-76.702476H119.781669C67.021288 51.395048 24.208335 94.305524 24.208335 147.163429v753.371428c0 52.809143 42.812952 95.768381 95.573334 95.768381h375.466666l82.797715-76.55619H119.781669v-0.097524z" fill="#ff7f2e" p-id="5666"></path></svg>
                            </div>
                        </div>
                        <div class="data-echarts-container">
                            <tea-station-echart :count1="postInfo.teachCount"
                                                :count2="postInfo.adminCount"
                                                :count3="postInfo.logisticsCount"
                                                :count4="postInfo.supportCount"/>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 数据看板-协同备课 -->
            <div class="dashboard-container" v-if="activeItem==='2'">
                <div class="data-info-container">
                    <div class="data-container-child1">
                        <div class="data-title-1">{{lessonData.lessonCount}}</div>
                        <div class="data-title-2">备课总数</div>
                    </div>
                    <div class="data-container-child1">
                        <div class="data-title-1">{{lessonData.xtLessonCount}}</div>
                        <div class="data-title-2">协同备课</div>
                    </div>
                    <div class="data-container-child1">
                        <div class="data-title-1">{{lessonData.grLessonCount}}</div>
                        <div class="data-title-2">个人备课</div>
                    </div>
                    <div class="data-container-child12">
                        <div class="data-title-1"> {{lessonData.teacherCount }} </div>
                        <div class="data-title-2">参与教师</div>
                    </div>
                </div>
                <div class="data-dashboard-top">
                    <div class="data-dashboard1" v-loading="loading1">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">教研方式分布</div>
                                <div :class="period1==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period1==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period1==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'3')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper">
                                <el-select size="small"
                                           v-model="yearCode1"
                                           @change="changeYearCode(1)"
                                           placeholder="年份">
                                    <el-option v-for="item in yearList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </div>
                        </div>
                        <div class="data-echarts-container">
                            <lesson-type-echart :count1="lessonTypeData.xtLessonCount" :count2="lessonTypeData.grLessonCount"/>
                        </div>
                    </div>
                    <div class="data-dashboard1" v-loading="loading2">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">教研学科分布</div>
                                <div :class="period2==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period2==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period2==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'3')"  v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper">
                                <el-select size="small"
                                           v-model="yearCode2"
                                           @change="changeYearCode(2)"
                                           placeholder="年份">
                                    <el-option v-for="item in yearList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </div>
                        </div>
                        <div class="data-echarts-container">
                            <lesson-subject-echart :item-list="lessonSubjectData.subjectList" :count-list="lessonSubjectData.countList"/>
                        </div>
                    </div>
                    <div class="data-dashboard2" v-loading="loading3">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">教研人数分布</div>
                                <div :class="period3==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period3==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period3==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'3')"  v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper">
                                <el-select size="small"
                                           v-model="yearCode3"
                                           @change="changeYearCode(3)"
                                           placeholder="年份">
                                    <el-option v-for="item in yearList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </div>
                        </div>
                        <div class="data-echarts-container">
                            <lesson-people-num-echart :item-list="lessonNumData.subjectList" :count-list="lessonNumData.countList"/>
                        </div>
                    </div>
                </div>
                <div class="data-dashboard-bottom">
                    <div class="data-dashboard1" v-loading="loading4">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">教研时间分布</div>
                                <div :class="period4==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period4==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period4==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'3')"  v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper">
                                <el-select size="small"
                                           v-model="yearCode4"
                                           @change="changeYearCode(4)"
                                           placeholder="年份">
                                    <el-option v-for="item in yearList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </div>
                        </div>
                        <div class="data-echarts-container">
                            <lesson-year-time-echart :month-list="lessonYearData.monthList" :one-count-list="lessonYearData.oneCountList" :two-count-list="lessonYearData.twoCountList"/>
                        </div>
                    </div>
                    <div class="data-dashboard1" v-loading="loading5">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">教研学科教龄分布</div>
                                <div :class="period5==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(5,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period5==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(5,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period5==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(5,'3')"  v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper">
                                <el-select size="small"
                                           v-model="yearCode5"
                                           @change="changeYearCode(5)"
                                           placeholder="年份">
                                    <el-option v-for="item in yearList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </div>
                        </div>
                        <div class="data-echarts-container01">
                            <lesson-age-subject-echart :one-count-list="lessonTeachAgeData.oneCountList"
                                                       :two-count-list="lessonTeachAgeData.twoCountList"
                                                       :three-count-list="lessonTeachAgeData.threeCountList"
                                                       :four-count-list="lessonTeachAgeData.fourCountList"
                                                       :item-list="lessonTeachAgeData.itemList" />
                        </div>
                        <div class="echarts-color-item-container">
                            <div class="echarts-color1"></div>
                            <div class="echarts-color-title">教龄1-5年</div>
                            <div class="echarts-color2"></div>
                            <div class="echarts-color-title">教龄5-10年</div>
                            <div class="echarts-color3"></div>
                            <div class="echarts-color-title">教龄10年以上</div>
                            <div class="echarts-color4"></div>
                            <div class="echarts-color-title">其他</div>
                        </div>
                    </div>
                    <div class="data-dashboard2" v-loading="loading6">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">不同年龄教研分布</div>
                                <div :class="period6==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(6,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period6==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(6,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period6==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(6,'3')"  v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper">
                                <el-select size="small"
                                           v-model="yearCode6"
                                           @change="changeYearCode(6)"
                                           placeholder="年份">
                                    <el-option v-for="item in yearList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </div>
                        </div>
                        <div class="data-echarts-container">
                            <lesson-age-echart :age1-count="lessonAgeData.age1Count"
                                               :age2-count="lessonAgeData.age2Count"
                                               :age3-count="lessonAgeData.age3Count"
                                               :age4-count="lessonAgeData.age4Count"
                                               :age5-count="lessonAgeData.age5Count"
                                               :age6-count="lessonAgeData.age6Count"/>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 数据看板-听评课 -->
            <div class="dashboard-container" v-if="activeItem==='3'">
                <div class="data-info-container">
                    <div class="data-container-child1">
                        <div class="data-title-1">{{evaData.evaCount}}</div>
                        <div class="data-title-2">听评课总节数</div>
                    </div>
                    <div class="data-container-child1">
                        <div class="data-title-1">{{evaData.evaPeopleCount}}</div>
                        <div class="data-title-2">听评课总人次</div>
                    </div>
                    <div class="data-container-child1">
                        <div class="data-title-1">{{evaData.evaTeacherCount}}</div>
                        <div class="data-title-2">听评课教师数</div>
                    </div>
                    <div class="data-container-child12">
                        <div class="data-title-1">{{evaData.onlineEvaCount}}</div>
                        <div class="data-title-2">在线听评课数</div>
                    </div>
                </div>
                <div class="data-dashboard-top">
                    <div class="data-dashboard1" v-loading="loading1">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">听评课方式分布</div>
                                <div :class="period1==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period1==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period1==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(1,'3')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper">
                                <el-select size="small"
                                           v-model="yearCode1"
                                           @change="changeYearCode(1)"
                                           placeholder="年份">
                                    <el-option v-for="item in yearList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </div>
                        </div>
                        <div class="data-echarts-container">
                            <eva-type-echart :count1="evaTypeData.tmEvaCount" :count2="evaTypeData.lbEvaCount" :count3="evaTypeData.zbEvaCount"/>
                        </div>
                    </div>
                    <div class="data-dashboard1" v-loading="loading2">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">听评课学科分布</div>
                                <div :class="period2==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period2==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period2==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(2,'3')"  v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper">
                                <el-select size="small"
                                           v-model="yearCode2"
                                           @change="changeYearCode(2)"
                                           placeholder="年份">
                                    <el-option v-for="item in yearList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </div>
                        </div>
                        <div class="data-echarts-container">
                            <eva-subject-echart :item-list="evaSubjectData.subjectList" :count-list="evaSubjectData.countList"/>
                        </div>
                    </div>
                    <div class="data-dashboard2" v-loading="loading3">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">听评课人数分布</div>
                                <div :class="period3==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period3==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period3==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(3,'3')"  v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper">
                                <el-select size="small"
                                           v-model="yearCode3"
                                           @change="changeYearCode(3)"
                                           placeholder="年份">
                                    <el-option v-for="item in yearList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </div>
                        </div>
                        <div class="data-echarts-container">
                            <eva-people-num-echart :item-list="evaNumData.subjectList" :count-list="evaNumData.countList" />
                        </div>
                    </div>
                </div>
                <div class="data-dashboard-bottom">
                    <div class="data-dashboard1" v-loading="loading4">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">听评课时间分布</div>
                                <div :class="period4==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period4==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period4==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(4,'3')"  v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper">
                                <el-select size="small"
                                           v-model="yearCode4"
                                           @change="changeYearCode(4)"
                                           placeholder="年份">
                                    <el-option v-for="item in yearList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </div>
                        </div>
                        <div class="data-echarts-container">
                            <eva-year-time-echart :month-list="evaYearData.monthList"
                                                  :one-count-list="evaYearData.oneCountList"
                                                  :two-count-list="evaYearData.twoCountList"
                                                  :three-count-list="evaYearData.threeCountList" />
                        </div>
                    </div>
                    <div class="data-dashboard1" v-loading="loading5">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">听评课学科教龄分布</div>
                                <div :class="period5==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(5,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period5==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(5,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period5==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(5,'3')"  v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper">
                                <el-select size="small"
                                           v-model="yearCode5"
                                           @change="changeYearCode(5)"
                                           placeholder="年份">
                                    <el-option v-for="item in yearList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </div>
                        </div>
                        <div class="data-echarts-container01">
                            <eva-age-subject-echart :one-count-list="evaTeachAgeData.oneCountList"
                                                    :two-count-list="evaTeachAgeData.twoCountList"
                                                    :three-count-list="evaTeachAgeData.threeCountList"
                                                    :four-count-list="evaTeachAgeData.fourCountList"
                                                    :item-list="evaTeachAgeData.itemList"/>
                        </div>
                        <div class="echarts-color-item-container">
                            <div class="echarts-color1"></div>
                            <div class="echarts-color-title">教龄1-5年</div>
                            <div class="echarts-color2"></div>
                            <div class="echarts-color-title">教龄5-10年</div>
                            <div class="echarts-color3"></div>
                            <div class="echarts-color-title">教龄10年以上</div>
                            <div class="echarts-color4"></div>
                            <div class="echarts-color-title">其他</div>
                        </div>
                    </div>
                    <div class="data-dashboard2" v-loading="loading6">
                        <div class="data-dashboard-title-container">
                            <div class="data-dashboard-title">
                                <div class="data-title">不同年龄听评课分布</div>
                                <div :class="period6==='1'?'data-item data-item-active':'data-item'" @click="changePeriod(6,'1')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('1')">小学</div>
                                <div :class="period6==='2'?'data-item data-item-active':'data-item'" @click="changePeriod(6,'2')" v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('2')">初中</div>
                                <div :class="period6==='3'?'data-item data-item-active':'data-item'" @click="changePeriod(6,'3')"  v-if="this.schoolPeriodInfo&&this.schoolPeriodInfo.includes('3')">高中</div>
                            </div>
                            <div class="data-dashboard-oper">
                                <el-select size="small"
                                           v-model="yearCode6"
                                           @change="changeYearCode(6)"
                                           placeholder="年份">
                                    <el-option v-for="item in yearList" :key="item.value" :label="item.name"
                                               :value="item.value" />
                                </el-select>
                            </div>
                        </div>
                        <div class="data-echarts-container">
                            <eva-age-echart :age1-count="evaAgeData.age1Count"
                                            :age2-count="evaAgeData.age2Count"
                                            :age3-count="evaAgeData.age3Count"
                                            :age4-count="evaAgeData.age4Count"
                                            :age5-count="evaAgeData.age5Count"
                                            :age6-count="evaAgeData.age6Count"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <el-dialog title="学校岗位分布数据" v-model="isPostFormShow" width="360px">
        <el-form ref="meetingFormRef" :rules="postFormRules" :model="postForm" label-width="80px" class="meeting-form">
            <el-row>
                <el-form-item class="pull-right" label="学校名称">
                    <el-input v-model="schoolInfo.orgName" disabled></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item class="pull-right" label="教学教研" prop="teachCount">
                    <el-input v-model="postForm.teachCount" ></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item class="pull-right" label="行政管理" prop="adminCount">
                    <el-input v-model="postForm.adminCount" ></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item class="pull-right" label="后勤服务" prop="logisticsCount">
                    <el-input v-model="postForm.logisticsCount" ></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item class="pull-right" label="专项支持" prop="supportCount">
                    <el-input v-model="postForm.supportCount" ></el-input>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item>
                    <el-button type="primary" @click="submitPostForm">确定</el-button>
                    <el-button @click="isPostFormShow = !isPostFormShow">取消</el-button>
                </el-form-item>
            </el-row>
        </el-form>
    </el-dialog>
</template>

<script>

import {timestampToTime} from "@/utils/date";
import {orgListUserSchool} from "@/api/admin/public";
import teaXbEchart from "@/components/schoolDashboard/tea/teaXbEchart.vue";
import teaXlEchart from "@/components/schoolDashboard/tea/teaXlEchart.vue";
import teaZcEchart from "@/components/schoolDashboard/tea/teaZcEchart.vue";
import teaAgeEchart from "@/components/schoolDashboard/tea/teaAgeEchart.vue";
import teaWorkAgeEchart from "@/components/schoolDashboard/tea/teaWorkAgeEchart.vue";
import teaSubjectEchart from "@/components/schoolDashboard/tea/teaSubjectEchart.vue";
import teaWorkAgeSubjectEchart from "@/components/schoolDashboard/tea/teaWorkAgeSubjectEchart.vue";
import teaStationEchart from "@/components/schoolDashboard/tea/teaStationEchart.vue";

import lessonTypeEchart from "@/components/schoolDashboard/lesson/lessonTypeEchart.vue";
import lessonSubjectEchart from "@/components/schoolDashboard/lesson/lessonSubjectEchart.vue";
import lessonPeopleNumEchart from "@/components/schoolDashboard/lesson/lessonPeopleNumEchart.vue";
import lessonYearTimeEchart from "@/components/schoolDashboard/lesson/lessonYearTimeEchart.vue";
import lessonAgeSubjectEchart from "@/components/schoolDashboard/lesson/lessonAgeSubjectEchart.vue";
import lessonAgeEchart from "@/components/schoolDashboard/lesson/lessonAgeEchart.vue";

import evaTypeEchart from "@/components/schoolDashboard/eva/evaTypeEchart.vue";
import evaSubjectEchart from "@/components/schoolDashboard/eva/evaSubjectEchart.vue";
import evaPeopleNumEchart from "@/components/schoolDashboard/eva/evaPeopleNumEchart.vue";
import evaYearTimeEchart from "@/components/schoolDashboard/eva/evaYearTimeEchart.vue";
import evaAgeSubjectEchart from "@/components/schoolDashboard/eva/evaAgeSubjectEchart.vue";
import evaAgeEchart from "@/components/schoolDashboard/eva/evaAgeEchart.vue";
import {ElLoading} from "element-plus";
import {
    teacherData,
    teacherOverview,
    teacherAge,
    teacherTeachAge,
    teacherSubject,
    teacherTeachAgeSubject,
    createTeacherPost,
    teacherPost,

    lessonData,
    lessonTypeData,
    lessonSubjectData,
    lessonNumData,
    lessonYearData,
    lessonTeachAgeData,
    lessonAgeData,

    evaData,
    evaTypeData,
    evaSubjectData,
    evaNumData,
    evaYearData,
    evaTeachAgeData,
    evaAgeData,


} from "@/api/admin/schoolDashboard"

export default {
    name: "schoolDashboard",
    components: {
        teaXbEchart,teaXlEchart,teaZcEchart,teaAgeEchart,teaWorkAgeEchart,teaSubjectEchart,teaWorkAgeSubjectEchart,teaStationEchart,
        lessonTypeEchart,lessonSubjectEchart,lessonPeopleNumEchart,lessonYearTimeEchart,lessonAgeSubjectEchart,lessonAgeEchart,
        evaTypeEchart,evaSubjectEchart,evaPeopleNumEchart,evaYearTimeEchart,evaAgeSubjectEchart,evaAgeEchart
    },
    data() {
        return {
            role:this.$storage.get("role"),
            timestampToTime,
            loading1: false,
            loading2: false,
            loading3: false,
            loading4: false,
            loading5: false,
            loading6: false,
            activeItem:"1",
            userInfo : JSON.parse(this.$storage.get("userInfo")),
            schoolList:[],
            schoolInfo:{},
            schoolId:'',
            schoolPeriodInfo:'',// 学校学段集合
            period1:'',
            period2:'',
            period3:'',
            period4:'',
            period5:'',
            period6:'',
            //教师发展
            queryTeaForm:{
                orgId:'',
                period:''
            },
            teaData:{},
            teaOverview:{},
            teaAge:{},
            teaWorkAge:{},
            teaSubject:{},
            teaTeachAgeSubject:{},
            isPostFormShow:false,
            postInfo:{},
            postForm:{
                orgId:'',
                teachCount:0,
                adminCount:0,
                logisticsCount:0,
                supportCount:0,
            },
            postFormRules: {},
            // 年份
            yearCode1:'',
            yearCode2:'',
            yearCode3:'',
            yearCode4:'',
            yearCode5:'',
            yearCode6:'',
            //协同备课
            yearList: [
                { name: '2025年', value: 2025 },
                { name: '2024年', value: 2024 },
                { name: '2023年', value: 2023 },
            ],
            queryLessonForm:{
                orgId:'',
                period:'',
                yearCode:''
            },
            lessonData:{},
            lessonTypeData:{},
            lessonSubjectData:{},
            lessonNumData:{},
            lessonYearData:{},
            lessonTeachAgeData:{},
            lessonAgeData:{},
            //听评课
            queryEvaForm:{
                orgId:'',
                period:'',
                yearCode:''
            },
            evaData:{},
            evaTypeData:{},
            evaSubjectData:{},
            evaNumData:{},
            evaYearData:{},
            evaTeachAgeData:{},
            evaAgeData:{},

        };
    },
    created() {
        this.getSchoolList();
    },
    mounted() {},
    activated() {},
    computed:{
        timestamp(){
            return new Date().getTime();
        }
    },
    methods: {
        changeItem(item){
            this.period1 = '';
            this.period2 = '';
            this.period3 = '';
            this.period4 = '';
            this.period5 = '';
            this.period6 = '';
            this.yearCode1 = '';
            this.yearCode2 = '';
            this.yearCode3 = '';
            this.yearCode4 = '';
            this.yearCode5 = '';
            this.yearCode6 = '';
            this.queryTeaForm.period = '';
            this.queryLessonForm.period = '';
            this.queryLessonForm.yearCode = '';
            this.queryEvaForm.period = '';
            this.queryEvaForm.yearCode = ''
            this.activeItem = item;
            if (this.activeItem==='1'){
                this.queryTeacherData();
                this.queryTeacherOverview();
                this.queryTeacherAge();
                this.queryTeacherTeachAge();
                this.queryTeacherSubject();
                this.queryTeacherTeachAgeSubject();
                this.queryTeacherPost();
            }
            if (this.activeItem==='2'){
                this.queryLessonData();
                this.queryLessonTypeData();
                this.queryLessonSubjectData();
                this.queryLessonNumData();
                this.queryLessonYearData();
                this.queryLessonTeachAgeData();
                this.queryLessonAgeData();
            }
            if (this.activeItem==='3'){
                this.queryEvaData();
                this.queryEvaTypeData();
                this.queryEvaSubjectData();
                this.queryEvaNumData();
                this.queryEvaYearData();
                this.queryEvaTeachAgeData();
                this.queryEvaAgeData();
            }
        },
        getSchoolList() {
            const loading = ElLoading.service({ fullscreen: true })
            orgListUserSchool().then(res => {
                if (res.data.code === 1){
                    this.schoolList = res.data.data;
                    this.schoolInfo = this.schoolList[0];
                    this.schoolId = this.schoolInfo.orgId;
                    this.queryTeaForm.orgId = this.schoolInfo.orgId;
                    this.queryLessonForm.orgId = this.schoolInfo.orgId;
                    this.queryEvaForm.orgId = this.schoolInfo.orgId;
                    this.postForm.orgId = this.schoolInfo.orgId;
                    this.schoolPeriodInfo = this.schoolInfo.periodInfo;
                    if (this.activeItem==='1'){
                        this.queryTeacherData();
                        this.queryTeacherOverview();
                        this.queryTeacherAge();
                        this.queryTeacherTeachAge();
                        this.queryTeacherSubject();
                        this.queryTeacherTeachAgeSubject();
                        this.queryTeacherPost();
                    }
                    if (this.activeItem==='2'){
                        this.queryLessonData();
                        this.queryLessonTypeData();
                        this.queryLessonSubjectData();
                        this.queryLessonNumData();
                        this.queryLessonYearData();
                        this.queryLessonTeachAgeData();
                        this.queryLessonAgeData();
                    }
                    if (this.activeItem==='3'){
                        this.queryEvaData();
                        this.queryEvaTypeData();
                        this.queryEvaSubjectData();
                        this.queryEvaNumData();
                        this.queryEvaYearData();
                        this.queryEvaTeachAgeData();
                        this.queryEvaAgeData();
                    }
                    loading.close()
                }else {
                    this.$message.error("服务异常")
                    loading.close()
                }
            })
        },
        schoolChange(item){
            this.schoolList.forEach(e => {
                if (e.orgId===item){
                    this.schoolId=item;
                    this.schoolInfo=e;
                    this.schoolId = this.schoolInfo.orgId;
                    this.queryTeaForm.orgId = this.schoolInfo.orgId;
                    this.queryTeaForm.period = '';
                    this.queryLessonForm.orgId = this.schoolInfo.orgId;
                    this.postForm.orgId = this.schoolInfo.orgId;
                    this.queryLessonForm.period = '';
                    this.queryLessonForm.yearCode = '';
                    this.queryEvaForm.orgId = this.schoolInfo.orgId;
                    this.queryEvaForm.period = '';
                    this.queryEvaForm.yearCode = ''
                    this.queryTeaForm.period = "";
                    this.period1 = '';
                    this.period2 = '';
                    this.period3 = '';
                    this.period4 = '';
                    this.period5 = '';
                    this.period6 = '';
                    this.yearCode1 = '';
                    this.yearCode2 = '';
                    this.yearCode3 = '';
                    this.yearCode4 = '';
                    this.yearCode5 = '';
                    this.yearCode6 = '';
                    this.schoolPeriodInfo = this.schoolInfo.periodInfo;
                    if (this.activeItem==='1'){
                        this.queryTeacherData();
                        this.queryTeacherOverview();
                        this.queryTeacherAge();
                        this.queryTeacherTeachAge();
                        this.queryTeacherSubject();
                        this.queryTeacherTeachAgeSubject();
                        this.queryTeacherPost();
                    }
                    if (this.activeItem==='2'){
                        this.queryLessonData();
                        this.queryLessonTypeData();
                        this.queryLessonSubjectData();
                        this.queryLessonNumData();
                        this.queryLessonYearData();
                        this.queryLessonTeachAgeData();
                        this.queryLessonAgeData();
                    }
                    if (this.activeItem==='3'){
                        this.queryEvaData();
                        this.queryEvaTypeData();
                        this.queryEvaSubjectData();
                        this.queryEvaNumData();
                        this.queryEvaYearData();
                        this.queryEvaTeachAgeData();
                        this.queryEvaAgeData();
                    }
                }
            })
        },
        /*========学段切换========*/
        changePeriod(num,periodKey){
            // 教师发展
            if (this.activeItem==='1'){
                if (num === 1){
                    this.period1 = periodKey;
                    this.queryTeaForm.period = periodKey;
                    this.queryTeacherOverview();
                }
                if (num === 2){
                    this.period2 = periodKey;
                    this.queryTeaForm.period = periodKey;
                    this.queryTeacherAge();
                }
                if (num === 3){
                    this.period3 = periodKey;
                    this.queryTeaForm.period = periodKey;
                    this.queryTeacherTeachAge();
                }
                if (num === 4){
                    this.period4 = periodKey;
                    this.queryTeaForm.period = periodKey;
                    this.queryTeacherSubject();
                }
                if (num === 5){
                    this.period5 = periodKey;
                    this.queryTeaForm.period = periodKey;
                    this.queryTeacherTeachAgeSubject();
                }
            }
            // 协同备课
            if (this.activeItem==='2'){
                if (num === 1){
                    this.period1 = periodKey;
                    this.queryLessonForm.period = periodKey;
                    this.queryLessonTypeData();
                }
                if (num === 2){
                    this.period2 = periodKey;
                    this.queryLessonForm.period = periodKey;
                    this.queryLessonSubjectData();
                }
                if (num === 3){
                    this.period3 = periodKey;
                    this.queryLessonForm.period = periodKey;
                    this.queryLessonNumData();
                }
                if (num === 4){
                    this.period4 = periodKey;
                    this.queryLessonForm.period = periodKey;
                    this.queryLessonYearData();
                }
                if (num === 5){
                    this.period5 = periodKey;
                    this.queryLessonForm.period = periodKey;
                    this.queryLessonTeachAgeData();
                }
                if (num === 6){
                    this.period6 = periodKey;
                    this.queryLessonForm.period = periodKey;
                    this.queryLessonAgeData();
                }
            }
            // 听评课
            if (this.activeItem==='3'){
                if (num === 1){
                    this.period1 = periodKey;
                    this.queryEvaForm.period = periodKey;
                    this.queryEvaTypeData();
                }
                if (num === 2){
                    this.period2 = periodKey;
                    this.queryEvaForm.period = periodKey;
                    this.queryEvaSubjectData();
                }
                if (num === 3){
                    this.period3 = periodKey;
                    this.queryEvaForm.period = periodKey;
                    this.queryEvaNumData();
                }
                if (num === 4){
                    this.period4 = periodKey;
                    this.queryEvaForm.period = periodKey;
                    this.queryEvaYearData();
                }
                if (num === 5){
                    this.period5 = periodKey;
                    this.queryEvaForm.period = periodKey;
                    this.queryEvaTeachAgeData();
                }
                if (num === 6){
                    this.period6 = periodKey;
                    this.queryEvaForm.period = periodKey;
                    this.queryEvaAgeData();
                }
            }

        },
        changeYearCode(num){
            // 协同备课
            if (this.activeItem==='2'){
                if (num === 1){
                    this.queryLessonForm.yearCode = this.yearCode1;
                    this.queryLessonTypeData();
                }
                if (num === 2){
                    this.queryLessonForm.yearCode = this.yearCode2;
                    this.queryLessonSubjectData();
                }
                if (num === 3){
                    this.queryLessonForm.yearCode = this.yearCode3;
                    this.queryLessonNumData();
                }
                if (num === 4){
                    this.queryLessonForm.yearCode = this.yearCode4;
                    this.queryLessonYearData();
                }
                if (num === 5){
                    this.queryLessonForm.yearCode = this.yearCode5;
                    this.queryLessonTeachAgeData();
                }
                if (num === 6){
                    this.queryLessonForm.yearCode = this.yearCode6;
                    this.queryLessonAgeData();
                }

            }

            // 听评课
            if (this.activeItem==='3'){
                if (num === 1){
                    this.queryEvaForm.yearCode = this.yearCode1;
                    this.queryEvaTypeData();
                }
                if (num === 2){
                    this.queryEvaForm.yearCode = this.yearCode2;
                    this.queryEvaSubjectData();
                }
                if (num === 3){
                    this.queryEvaForm.yearCode = this.yearCode3;
                    this.queryEvaNumData();
                }
                if (num === 4){
                    this.queryEvaForm.yearCode = this.yearCode4;
                    this.queryEvaYearData();
                }
                if (num === 5){
                    this.queryEvaForm.yearCode = this.yearCode5;
                    this.queryEvaTeachAgeData();
                }
                if (num === 6){
                    this.queryEvaForm.yearCode = this.yearCode6;
                    this.queryEvaAgeData();
                }

            }
        },
        /*========教师发展========*/
        // 各维度教师统计数量
        queryTeacherData(){
            teacherData({orgId:this.schoolId}).then(res => {
                if (res.data.code === 1){
                    this.teaData = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        queryTeacherOverview(){
            this.loading1 = true;
            teacherOverview(this.queryTeaForm).then(res => {
                if (res.data.code === 1){
                    this.teaOverview = res.data.data;
                    this.loading1 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading1 = false;
                }
            })
        },
        queryTeacherAge(){
            this.loading2 = true;
            teacherAge(this.queryTeaForm).then(res => {
                if (res.data.code === 1){
                    this.teaAge = res.data.data;
                    this.loading2 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading2 = false;
                }
            })
        },
        queryTeacherTeachAge(){
            this.loading3 = true;
            teacherTeachAge(this.queryTeaForm).then(res => {
                if (res.data.code === 1){
                    this.teaWorkAge = res.data.data;
                    this.loading3 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading3 = false;
                }
            })
        },
        queryTeacherSubject(){
            this.loading4 = true;
            teacherSubject(this.queryTeaForm).then(res => {
                if (res.data.code === 1){
                    this.teaSubject = res.data.data;
                    this.loading4 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading4 = false;
                }
            })
        },
        queryTeacherTeachAgeSubject(){
            this.loading5 = true;
            teacherTeachAgeSubject(this.queryTeaForm).then(res => {
                if (res.data.code === 1){
                    this.teaTeachAgeSubject = res.data.data;
                    this.loading5 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading5 = false;
                }
            })
        },
        queryTeacherPost(){
            this.loading6 = true;
            teacherPost({orgId:this.schoolId}).then(res => {
                if (res.data.code === 1){
                    this.postInfo = res.data.data;
                    this.loading6 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading6 = false;
                }
            })
        },
        createPostInfo(){
            this.isPostFormShow = true;
            this.postForm.teachCount = this.postInfo.teachCount;
            this.postForm.adminCount = this.postInfo.adminCount;
            this.postForm.logisticsCount = this.postInfo.logisticsCount;
            this.postForm.supportCount = this.postInfo.supportCount;
        },
        submitPostForm(){
            createTeacherPost(this.postForm).then(res => {
                if (res.data.code === 1){
                    this.queryTeacherPost();
                    this.isPostFormShow = false;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        /*========协同备课========*/
        queryLessonData(){
            lessonData({orgId:this.schoolId}).then(res => {
                if (res.data.code === 1){
                    this.lessonData = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        queryLessonTypeData(){
            this.loading1 = true;
            lessonTypeData(this.queryLessonForm).then(res => {
                if (res.data.code === 1){
                    this.lessonTypeData = res.data.data;
                    this.loading1 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading1 = false;
                }
            })
        },
        queryLessonSubjectData(){
            this.loading2 = true;
            lessonSubjectData(this.queryLessonForm).then(res => {
                if (res.data.code === 1){
                    this.lessonSubjectData = res.data.data;
                    this.loading2 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading2 = false;
                }
            })
        },
        queryLessonNumData(){
            this.loading3 = true;
            lessonNumData(this.queryLessonForm).then(res => {
                if (res.data.code === 1){
                    this.lessonNumData = res.data.data;
                    this.loading3 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading3 = false;
                }
            })
        },
        queryLessonYearData(){
            this.loading4 = true;
            lessonYearData(this.queryLessonForm).then(res => {
                if (res.data.code === 1){
                    this.lessonYearData = res.data.data;
                    this.loading4 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading4 = false;
                }
            })
        },
        queryLessonTeachAgeData(){
            this.loading5 = true;
            lessonTeachAgeData(this.queryLessonForm).then(res => {
                if (res.data.code === 1){
                    this.lessonTeachAgeData = res.data.data;
                    this.loading5 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading5 = false;
                }
            })
        },
        queryLessonAgeData(){
            this.loading6 = true;
            lessonAgeData(this.queryLessonForm).then(res => {
                if (res.data.code === 1){
                    this.lessonAgeData = res.data.data;
                    this.loading6 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading6 = false;
                }
            })
        },
        /*========听评课========*/
        queryEvaData(){
            evaData({orgId:this.schoolId}).then(res => {
                if (res.data.code === 1){
                    this.evaData = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        queryEvaTypeData(){
            this.loading1 = true;
            evaTypeData(this.queryEvaForm).then(res => {
                if (res.data.code === 1){
                    this.evaTypeData = res.data.data;
                    this.loading1 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading1 = false;
                }
            })
        },
        queryEvaSubjectData(){
            this.loading2 = true;
            evaSubjectData(this.queryEvaForm).then(res => {
                if (res.data.code === 1){
                    this.evaSubjectData = res.data.data;
                    this.loading2 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading2 = false;
                }
            })
        },
        queryEvaNumData(){
            this.loading3 = true;
            evaNumData(this.queryEvaForm).then(res => {
                if (res.data.code === 1){
                    this.evaNumData = res.data.data;
                    this.loading3 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading3 = false;
                }
            })
        },
        queryEvaYearData(){
            this.loading4 = true;
            evaYearData(this.queryEvaForm).then(res => {
                if (res.data.code === 1){
                    this.evaYearData = res.data.data;
                    this.loading4 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading4 = false;
                }
            })
        },
        queryEvaTeachAgeData(){
            this.loading5 = true;
            evaTeachAgeData(this.queryEvaForm).then(res => {
                if (res.data.code === 1){
                    this.evaTeachAgeData = res.data.data;
                    this.loading5 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading5 = false;
                }
            })
        },
        queryEvaAgeData(){
            this.loading6 = true;
            evaAgeData(this.queryEvaForm).then(res => {
                if (res.data.code === 1){
                    this.evaAgeData = res.data.data;
                    this.loading6 = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading6 = false;
                }
            })
        },
    }
};
</script>
<style scoped>
.stat-container{
    width: 100%;
    height: 100vh;
    background-color: #f1f1f1;
    display: flex;
    font-family: sans-serif;
}
/*左栏*/
.l-stat-container{
    width: 200px;
    height: 100vh;
    background-color: #dfe4f7;
}
.org-container{
    width: 100%;
    height: 140px;
    padding: 15px 5px 0 5px;
    box-sizing: border-box;
}
.org-logo-container{
    width: 60px;
    height: 60px;
    border-radius: 30px;
    margin: auto;
}
.org-logo{
    width: 60px;
    height: 60px;
    border-radius: 30px;
}
.school-name-container{
    width: 100%;
    height: 24px;
    line-height: 24px;
    text-align: center;
    color: #ff7f2e;
    font-size: 16px;
    font-weight: bold;
    font-family: sans-serif;
}
.org-name-container{
    width: 100%;
    height: 20px;
    text-align: center;
    color: #121212;
    font-size: 12px;
    font-weight: bold;
    font-family: sans-serif;
}
.menu-container{
    width: 100%;
    height: calc(100vh - 160px);
    background: #dfe4f7;
    padding-bottom: 15px;
    border-radius: 10px;
}
.menu-item{
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 15px;
    font-size: 15px;
    color: #707070;
    cursor: pointer;
}
.menu-active{
    background: #ff7f2e;
    color: #fff;
    //font-weight: bold;
}
/*右栏*/
.r-stat-container{
    width: calc(100% - 215px);
    height: 100vh;
    margin-left: 10px;
}
.school-info-container{
    width: 100%;
    height: 70px;
    background-color: #fff;
    margin-bottom: 10px;
    margin-top: 5px;
    display: flex;
    border-radius: 8px;
}
.l-school-info-container{
    width: 160px;
    height: 80px;
    margin-bottom: 10px;
}
.r-school-info-container{
    width: calc(100% - 320px);
    height: 80px;
    margin-bottom: 10px;
}
.r-school-info-container-child1{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #ff7f2e;
    font-size: 18px;
    font-weight: bold;
    font-family: sans-serif;
}
.r-school-info-container-child2{
    width: 100%;
    height: 30px;
    text-align: center;
    color: #121212;
    font-size: 14px;
    font-weight: bold;
    font-family: sans-serif;
}
.dashboard-container{
    width: 100%;
    height: calc(100vh - 90px);
}
.data-info-container{
    height: 70px;
    width: 100%;
    margin-bottom: 10px;
    display: flex;
}
.data-container-child1{
    width: 24.25%;
    height: 70px;
    margin-right: 1%;
    background-color: #fff;
    border-radius: 6px;
}
.data-container-child12{
    width: 24.25%;
    height: 70px;
    background-color: #fff;
    border-radius: 6px;
}
.data-title-1{
    height: 35px;
    line-height: 40px;
    color: #ee681a;
    text-align: center;
    font-weight: bold;
    font-size: 16px;

}
.data-title-2{
    height: 35px;
    line-height: 24px;
    color: #121212;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
}
.data-dashboard-top{
    width: 100%;
    height: calc(50vh - 90px);
    margin-bottom: 10px;
    display: flex;
}
.data-dashboard-bottom{
    width: 100%;
    height: calc(50vh - 90px);
    display: flex;
}
.data-dashboard1{
    width: 32.66%;
    height: calc(50vh - 90px);
    margin-right: 1%;
    background-color: #fff;
    border-radius: 6px;

}
.data-dashboard2{
    width: 32.66%;
    height: calc(50vh - 90px);
    background-color: #fff;
    border-radius: 6px;
}
.data-dashboard-title-container{
    width: 100%;
    height: 30px;
    display: flex;
}
.data-dashboard-title{
    width: calc(100% - 70px);
    height: 30px;
    display: flex;
}
.data-title{
    width: auto;
    height: 30px;
    padding: 0 10px 0 10px;
    line-height: 30px;
    color: #121212;
    text-align: center;
    font-weight: bold;
    font-size: 14px;
}
.data-item{
    width: auto;
    height: 20px;
    line-height: 20px;
    padding: 0 2px 0 2px;
    margin-top: 5px;
    margin-right: 5px;
    color: #101010;
    text-align: center;
    font-size: 12px;
    border: 1px solid #bbbbbb;
    border-radius: 5px;
    cursor: pointer;
    z-index: 99;
}
.data-item-active{
    color: #fff;
    background-color: #ff7f2e;
    text-align: center;
    font-size: 12px;
    border: 1px solid #ff7f2e;
}
.data-dashboard-oper{
    width: 70px;
    height: 30px;
    cursor: pointer;
    z-index: 99;
}

.data-echarts-container{
    width: 100%;
    height: calc(50vh - 120px);
    display: flex;
}

.data-echarts-container01{
    width: 100%;
    height: calc(50vh - 150px);
    display: flex;
}

.data-echarts-item{
    width: 33.3%;
    height: calc(50vh - 120px);
}
.item_container{
    width: 100%;
    height: calc(50vh - 220px);
    margin-top: -5px;
}
.item_01{
    width: 100%;
    height: 33.3%;
    padding-left: 10px;
    padding-bottom: 5px;
    box-sizing: border-box;
    display: flex;
}
.item_color1{
    width: 5px;
    height: 100%;
    background-color: #5087ec;
}
.item_color2{
    width: 5px;
    height: 100%;
    background-color: #68bbc4;
}
.item_color3{
    width: 5px;
    height: 100%;
    background-color: #58a55c;
}
.item_color4{
    width: 5px;
    height: 100%;
    background-color: #ee6616;
}
.item_info{
    width: calc(100% - 5px);
    height: 100%;
}
.item_info_c1{
    width: 100%;
    height: 50%;
    font-size: 13px;
    text-indent: 10px;
}
.item_info_c2{
    width: 100%;
    height: 50%;
    font-size: 13px;
    text-indent: 10px;
}

.echarts-color-item-container{
    width: 100%;
    height: 30px;
    z-index: 999;
    margin: auto;

    box-sizing: border-box;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
}
.echarts-color1{
    width: 15px;
    height: 10px;
    background-color: #68bbc4;
    border-radius: 2px;
    margin-right: 3px;
    margin-top: 2px;
}
.echarts-color2{
    width: 15px;
    height: 10px;
    background-color: #5087ec;
    border-radius: 2px;
    margin-right: 3px;
    margin-top: 2px;
}
.echarts-color3{
    width: 15px;
    height: 10px;
    background-color: #ffbf6b;
    border-radius: 2px;
    margin-right: 3px;
    margin-top: 2px;
}
.echarts-color4{
    width: 15px;
    height: 10px;
    background-color: #3ba272;
    border-radius: 2px;
    margin-right: 3px;
    margin-top: 2px;
}
.echarts-color-title{
    width: auto;
    height: 30px;
    line-height: 30px;
    font-size: 10px;
    color: #121212;
    padding: 0 2px 0 0;
}
</style>
